import React, { useState, useEffect, useCallback } from 'react';
import URLManager from '../funcionalidadeNavbar/URLManager';

const CompraFormulario = ({ compra, onSalvar, onCancelar }) => {
  const _url = URLManager.getBaseURL();
  const [formData, setFormData] = useState({
    fornecedorId: '',
    ordemProducaoId: '',
    status: 'ABERTA',
    observacao: '',
    itens: []
  });

  const [fornecedores, setFornecedores] = useState([]);
  const [materiasPrimas, setMateriasPrimas] = useState([]);
  const [itemAtual, setItemAtual] = useState({
    materiaPrimaId: '',
    quantidade: '',
    valorUnitario: ''
  });

  const carregarFornecedores = useCallback(async () => {
    try {
      const token = sessionStorage.getItem('usuarioToken');
      const response = await fetch(`${_url}/fornecedor/listar`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const data = await response.json();
        setFornecedores(data);
      }
    } catch (err) {
      console.error('Erro ao carregar fornecedores:', err);
    }
  }, [_url]);

  const carregarMateriasPrimas = useCallback(async () => {
    try {
      const token = sessionStorage.getItem('usuarioToken');
      const response = await fetch(`${_url}/materiaPrima/listar`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const data = await response.json();
        setMateriasPrimas(data);
      }
    } catch (err) {
      console.error('Erro ao carregar matérias-primas:', err);
    }
  }, [_url]);

  useEffect(() => {
    carregarFornecedores();
    carregarMateriasPrimas();
  }, [carregarFornecedores, carregarMateriasPrimas]);

  useEffect(() => {
    if (compra && compra.id) {
      setFormData({
        fornecedorId: compra.fornecedorId || '',
        ordemProducaoId: compra.ordemProducaoId || '',
        status: compra.status || 'ABERTA',
        observacao: compra.observacao || '',
        itens: compra.itens || []
      });
    }
  }, [compra]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleItemChange = (e) => {
    const { name, value } = e.target;
    setItemAtual(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const adicionarItem = () => {
    if (!itemAtual.materiaPrimaId || !itemAtual.quantidade || !itemAtual.valorUnitario) {
      alert('Preencha todos os campos do item');
      return;
    }

    const materiaPrima = materiasPrimas.find(mp => mp.id === parseInt(itemAtual.materiaPrimaId));
    
    const novoItem = {
      materiaPrimaId: parseInt(itemAtual.materiaPrimaId),
      materiaPrimaNome: materiaPrima?.descricao || '',
      quantidade: parseFloat(itemAtual.quantidade),
      valorUnitario: parseFloat(itemAtual.valorUnitario),
      subtotal: parseFloat(itemAtual.quantidade) * parseFloat(itemAtual.valorUnitario)
    };

    setFormData(prev => ({
      ...prev,
      itens: [...prev.itens, novoItem]
    }));

    setItemAtual({
      materiaPrimaId: '',
      quantidade: '',
      valorUnitario: ''
    });
  };

  const removerItem = (index) => {
    setFormData(prev => ({
      ...prev,
      itens: prev.itens.filter((_, i) => i !== index)
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.fornecedorId) {
      alert('Selecione um fornecedor');
      return;
    }

    if (formData.itens.length === 0) {
      alert('Adicione pelo menos um item à compra');
      return;
    }

    const compraData = {
      ...formData,
      fornecedorId: parseInt(formData.fornecedorId),
      ordemProducaoId: formData.ordemProducaoId ? parseInt(formData.ordemProducaoId) : null
    };

    onSalvar(compraData);
  };

  const calcularTotal = () => {
    return formData.itens.reduce((total, item) => total + item.subtotal, 0);
  };

  return (
    <div className="compra-formulario">
      <form onSubmit={handleSubmit}>
        <div className="form-section">
          <h3>Informações da Compra</h3>
          
          <div className="form-group">
            <label>Fornecedor *</label>
            <select
              name="fornecedorId"
              value={formData.fornecedorId}
              onChange={handleChange}
              required
            >
              <option value="">Selecione um fornecedor</option>
              {fornecedores.map(f => (
                <option key={f.id} value={f.id}>
                  {f.nomeEmpresa}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Ordem de Produção (opcional)</label>
            <input
              type="number"
              name="ordemProducaoId"
              value={formData.ordemProducaoId}
              onChange={handleChange}
              placeholder="ID da Ordem de Produção"
            />
          </div>

          <div className="form-group">
            <label>Observação</label>
            <textarea
              name="observacao"
              value={formData.observacao}
              onChange={handleChange}
              rows="3"
              placeholder="Observações sobre a compra"
            />
          </div>
        </div>

        <div className="form-section">
          <h3>Itens da Compra</h3>
          
          <div className="item-form">
            <div className="form-row">
              <div className="form-group">
                <label>Matéria-Prima *</label>
                <select
                  name="materiaPrimaId"
                  value={itemAtual.materiaPrimaId}
                  onChange={handleItemChange}
                >
                  <option value="">Selecione</option>
                  {materiasPrimas.map(mp => (
                    <option key={mp.id} value={mp.id}>
                      {mp.descricao} - {mp.cor}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Quantidade *</label>
                <input
                  type="number"
                  step="0.01"
                  name="quantidade"
                  value={itemAtual.quantidade}
                  onChange={handleItemChange}
                  placeholder="0.00"
                />
              </div>

              <div className="form-group">
                <label>Valor Unitário *</label>
                <input
                  type="number"
                  step="0.01"
                  name="valorUnitario"
                  value={itemAtual.valorUnitario}
                  onChange={handleItemChange}
                  placeholder="0.00"
                />
              </div>

              <div className="form-group">
                <button 
                  type="button" 
                  className="btn-adicionar-item"
                  onClick={adicionarItem}
                >
                  Adicionar Item
                </button>
              </div>
            </div>
          </div>

          {formData.itens.length > 0 && (
            <div className="itens-lista">
              <table>
                <thead>
                  <tr>
                    <th>Matéria-Prima</th>
                    <th>Quantidade</th>
                    <th>Valor Unit.</th>
                    <th>Subtotal</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {formData.itens.map((item, index) => (
                    <tr key={index}>
                      <td>{item.materiaPrimaNome}</td>
                      <td>{item.quantidade}</td>
                      <td>R$ {item.valorUnitario.toFixed(2)}</td>
                      <td>R$ {item.subtotal.toFixed(2)}</td>
                      <td>
                        <button
                          type="button"
                          className="btn-remover"
                          onClick={() => removerItem(index)}
                        >
                          Remover
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan="3"><strong>Total:</strong></td>
                    <td colSpan="2"><strong>R$ {calcularTotal().toFixed(2)}</strong></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          )}
        </div>

        <div className="form-actions">
          <button type="submit" className="btn-salvar">
            Salvar Compra
          </button>
          <button type="button" className="btn-cancelar" onClick={onCancelar}>
            Cancelar
          </button>
        </div>
      </form>
    </div>
  );
};

export default CompraFormulario;
